import { Component, OnInit } from '@angular/core';
import { pushPaginaAtiva, clearPaginas } from '../../shared/activePage';
@Component({
  selector: 'app-home',
  imports: [],
  templateUrl: './home.html',
  styleUrl: './home.scss'
})
export class Home implements OnInit {
  ngOnInit(): void {
    clearPaginas();
    pushPaginaAtiva({
        nome: 'Home',
        rota: ''
    });
  }
}
